const allCss = {
  'Showcase-Gambling Buttons-Desert Theme': `
.list-payment-methods {
  background: linear-gradient(25deg, #f1f1f1f1, #ffffff, #efdbc1)!important;
}
.set-amount .predefinedvalues button {
  border: 1.5px solid #ffffff!important;
}
  `,
  'Showcase-Gambling List-Le Bleu': `
  :root{
    --border-color: white!important;
  }
  .tabs.flex {
    background: #333333;
    background: linear-gradient(270deg,#4b6cb7,#182848);
    border-bottom: 3px solid white;
  }
  h3.payment-method-label.no-select.single-header {
    color: #ffffff;
    font-weight:bold;
  }
  .payment-method-header:hover {
    background: #002c52!important;
  }
  .btn:disabled:after {
    background-color: transparent!important;
  }
  .transaction-overview .transaction-overview-row {
    font-weight:bold;
  }
  .tabs .tab.active[data-v-412b304d]:after {
    background: white!important;
  }
  .all-transactions {
    background: #1c376b!important;
    box-shadow: 1px 1px 1px #333333!important;
  }
  .card.flex-item {
    background: #0d2044!important;
    box-shadow: 1px 1px 1px #333333!important;
  }
  .card.flex-item:hover {
    background: #213d71!important;
    box-shadow: 1px 1px 1px #333333!important;
  }
  `
}

export default allCss
